/**
 * Created by Ning Jiang on 2023-09-06.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {gsap} from "gsap";
import {DCRoadReelsController} from "../../reels/DCRoadReelsController";

export class ForbidSymbolsController extends WinPresentationController {

    private _lockedPositions:boolean[][];

    constructor() {
        super("ForbidSymbolsController", false);
        this.startNewRound();
        if(this.hasWin()) {
            this.forbidSymbols(true);
        }
    }

    protected hasWin():boolean {
        if(DevilsCrossRoad.model.data.placesHandled) {
            return DevilsCrossRoad.model.data.placesHandled.some((reelPlaces, reelId) => {
                return reelPlaces.some((symPlace, symId) => symPlace != this._lockedPositions[reelId][symId]);
            });
        }
        return false;
    }

    public startNewRound():void {
        this._lockedPositions = [
            [false, false, false, false, false],
            [false, false, false, false, false],
            [false, false, false, false, false],
            [false, false, false, false, false],
            [false, false, false, false, false]
        ];
    }

    protected async createWinAnimation():Promise<any> {
        return this.forbidSymbols(false);
    }

    private forbidSymbols(init:boolean):Promise<any> {
        const tl = gsap.timeline();
        DevilsCrossRoad.model.data.placesHandled.forEach((reelPlaces, reelId) => {
            reelPlaces.forEach((symPlace, symId) => {
                if(symPlace && !this._lockedPositions[reelId][symId]) {
                    this._lockedPositions[reelId][symId] = true;
                    const sym = DevilsCrossRoad.reels.getSymbol(reelId, symId);
                    if(sym) {
                        tl.add([
                            sym.playForbidden(),
                            () => {DevilsCrossRoad.multipliers.forbiddenMultiplier(DCRoadReelsController.DEV_WAYS_MAP[sym.reelId][sym.symId]);}
                        ], 0);
                    }
                }
            });
        });

        if(tl.totalDuration() > 0) {
            return Promise.resolve(tl);
        }
        return Promise.resolve();
    }
}